"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var TableSection_1 = __importDefault(require("./TableSection"));
var PlanSection_1 = __importDefault(require("./PlanSection"));
var Section = (0, mobx_react_1.observer)(function (_a) {
    var section = _a.section, selectSection = _a.selectSection;
    switch (section.displayMode) {
        case Types_1.QuoteSectionDisplayMode.PlanCards:
            return react_1.default.createElement(PlanSection_1.default, { section: section, selectSection: selectSection });
        case Types_1.QuoteSectionDisplayMode.Table:
        default:
            return react_1.default.createElement(TableSection_1.default, { section: section, selectSection: selectSection });
    }
});
exports.default = Section;
